//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueRecaptcha from "vue-recaptcha";
import md5 from "md5";
import { mapActions } from "vuex";
export default {
  name: "UserRegister",
  components: { VueRecaptcha },
  data: function() {
    return {
      user: {},
      model: null,
      isPwd: true,
      isPwd_2: true,
      remember: false,
      forgotpwd: false,
    };
  },
  methods: {
    ...mapActions(["getCurrentUser"]),

    save() {
      if (this.user.password == this.user.password_2) {
        this.user.password_3 = md5(this.user.password);
        var resetToken = this.$route.params.tkn;
        
        this.user.token = resetToken;
        this.showLoading = true;
        this.$http
          .post("/user/resetpassword", this.user, {})
          .then((result) => {
            this.$q.notify({
              icon: "done",
              color: "positive",
              message: "Password berhasil diubah!",
            });
            this.$router.push("/user/login");
          })
          .catch((error) => {
            this.$q.notify({
              color: "negative",
              message: "Token yang anda berikan tidak valid!",
            });
            this.$router.push("/user/login");
          });
      } else {
        this.$q.notify({
          color: "negative",
          message: "Password tidak sama!",
        });
      }
    },
  },
};
